import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
  loading: false,
  error: null,
};

const verifyUserSlice = createSlice({
  name: "verifyUser",
  initialState,
  reducers: {
    verifyUserAndSetPassword(state, action) {
      state.loading = true;
    },
    verifyUserAndSetPasswordSuccess(state, action) {
      state.loading = false;
    },
    verifyUserAndSetPasswordFailure(state, action) {
      state.loading = false;
      state.error = action.payload.message;
    },
    initializeError(state, action) {
      state.error = null;
    },
  },
});

export const { actions, reducer, name: sliceKey } = verifyUserSlice;
